// extracted by mini-css-extract-plugin
export default {"container":"style__container__AV8UL","otherConfig":"style__otherConfig__crhzn"};